<sm-spinner [loading]="loading$"></sm-spinner>
<div *ngIf="hasNoFields && document.isStatic === false"
  class="flex flex-row gap-4 items-center justify-center py-4 opacity-70">
  <i class="pi pi-info-circle text-2xl text-primary"></i>
  Aucun champ disponible pour ce document
</div>
<div class="px-2">
  <sm-form-builder [formObject]="formObject"></sm-form-builder>
  <sm-preview-pdf *ngIf="document.isStatic" [src]="pdfUrl"></sm-preview-pdf>
</div>